import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeyGenPromptEditorComponent } from './hey-gen-prompt-editor.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HeyGenPromptCreatorComponent } from './hey-gen-prompt-creator/hey-gen-prompt-creator.component';

@NgModule({ declarations: [
	HeyGenPromptEditorComponent,
	HeyGenPromptCreatorComponent
],
exports: [
	HeyGenPromptEditorComponent
], imports: [CommonModule,
	TranslateModule,
	FormsModule,
	GoMaterialModule,
	ReactiveFormsModule,
	A11yModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class HeyGenPromptEditorComponentModule {}
